import styled from 'styled-components'
import {
  darkBlue,
  darkSlateBlue,
  darkGrey,
  blueGray,
  grey,
  white,
  skyBlue,
  paleGray
} from '../../../styles/settings/colors'
import {
  title18Galano,
  title24Galano,
  txt16OpenSans,
  txt16OpenSansBold,
  txt14OpenSans
} from '../../../styles/settings/types'

import content from '../../../styles/_objects/content'
import rem from '../../../styles/tools/rem'
import media from '../../../styles/tools/media'

export const Content = styled.section`
  ${content};
  margin: ${rem('42px')} auto;

  ${media.small`
        margin: ${rem('29px')} auto;
    `};
`

export const Paragraph = styled.p`
  ${txt14OpenSans} color: ${darkBlue};

  margin-top: ${rem('7px')};

  ${media.large`

        margin: 0;
    `};

`

export const Heading = styled.h1`
  ${title24Galano}
  color: ${darkSlateBlue};
  font-size: 48px;
  font-weight: bold;
  line-height: 1.08;
  letter-spacing: normal;
  margin: 0;

  ${media.small`
        ${title18Galano}
        margin: ${rem('8px')} 0;
    `};
`

export const WrapperButtons = styled.div`
  display: flex;
  justify-content: start;
  min-width: 400px;
  & > div {
    margin: 0 0;
  }
`

export const WrapperRadios = styled.div`
  display: flex;
  justify-content: flex-start;
  min-width: 200px;
  & > div {
    margin: 0 0;
  }
`

export const BoxHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
`

export const SearchBox = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 40px;
`

export const WrapperAddress = styled.div``

export const CepText = styled.div`
  ${txt16OpenSans};
  color: ${darkGrey};
  width: 100%;
  padding-left: 30px;
  cursor: pointer;
  text-transform: ${props => props.transform};
`

CepText.defaultProps = {
  transform: 'capitalize'
}

export const NewAddress = styled.div`
  color: ${props => (props.focus ? `${darkSlateBlue}` : `${blueGray}`)};
  ${txt16OpenSans};
  letter-spacing: 0.4px;
  display: flex;
  flex-direction: column;
`

export const WrapperSelectNewAddress = styled.div``

export const CheckBoxCep = styled.input`
  margin-right: 15px;
  &:checked,
  &:not(:checked) {
    position: absolute;
    z-index: 99;
    margin-left: 2px;
    cursor: pointer;
  }
  &:checked + label,
  &:not(:checked) + label {
    position: relative;
    padding-left: 35px;
    line-height: 20px;
    display: inline-block;
  }
  &:checked,
  &:not(:checked) {
    &:before {
      content: '';
      position: absolute;
      left: -2px;
      top: 0;
      width: 20px;
      height: 20px;
      border: 2px solid ${grey};
      border-radius: 100%;
      background: ${white};
    }
  }
  &:checked {
    &:before {
      border: 2px solid ${skyBlue};
    }
  }
  &:checked,
  &:not(:checked) {
    &:after {
      content: '';
      width: 12px;
      height: 12px;
      background: ${skyBlue};
      position: absolute;
      top: 4px;
      left: 2px;
      border-radius: 100%;
      -webkit-transition: all 0.2s ease;
      transition: all 0.2s ease;
    }
  }
  &:not(:checked) {
    &:after {
      opacity: 0;
      -webkit-transform: scale(0);
      transform: scale(0);
    }
  }
  &:checked {
    &:after {
      opacity: 1;
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
`

export const WrapperFormNewAddress = styled.div`
  margin-top: 30px;
  /* form > div > div > div {
    width: 100%;
  } */
`

export const NewAddressText = styled.label``

export const BoxCep = styled.label`
  flex-grow: 1;
`

export const Row = styled.div`
  margin: 5px 0;
  display: inline-block;
  width: 100%;
`
export const Subtitle = styled.p`
  ${txt16OpenSans};

  color: ${darkBlue};
  font-weight: bold;
  line-height: 1;
  margin: 0 0 ${rem('10px')};
`

export const SearchInput = styled.input`
  border: none;
  border-bottom: 3px solid ${darkSlateBlue};
  background-color: ${paleGray};
  padding: ${rem('16px')};
  line-height: ${rem('24px')};
  color: ${darkSlateBlue};
  ${txt16OpenSans};
  width: 100%;
  text-indent: 40px;
`
export const Container = styled.section`
  width: 100%;
  padding: ${rem('9px')} 0 ${rem('50px')};
  background-color: white;
  display: flex;
  justify-content: center;
`

export const InputContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  width: ${rem('940px')};
  align-items: center;
`

export const SearchButton = styled.button`
  background-color: ${({ disabled }) => (disabled ? paleGray : darkSlateBlue)};
  color: ${({ disabled }) => (disabled ? darkGrey : 'white')};
  ${txt16OpenSansBold};
  padding: ${rem('13px')} ${rem('25px')};
  border-radius: 25px;
  margin-left: ${rem('20px')};
  outline: none;
`

export const Wrapper = styled.section`
  width: 100%;
  min-width: 100%;
  border-radius: ${rem('6px')};
  background-color: ${white};
  padding: ${rem('22px')};
  box-shadow: 0 ${rem('8px')} ${rem('8px')} 0 rgba(30, 27, 91, 0.11);
  display: flex;
  justify-content: space-around;

  ${media.large`
        padding: ${rem('40px')} ${rem('40px')} ${rem('30px')};
        width: ${rem('335px')};
    `};
`

export const Loading = styled.img`
  width: ${rem('25px')};
`

export const WrapperTextoHeader = styled.div`
  span {
    ${txt14OpenSans} color: ${darkBlue};

    margin-top: ${rem('7px')};
    margin-left: ${rem('5px')} !important;
    ${media.large`
          margin: 0;
      `};  position: relative;

  }
`

export const SearchIconContainer = styled.div`
  /* position: absolute;
  top: 20px; */
  left: 15px;
  width: 0;
  position: relative;
  display: flex;
  flex-direction: column;
`

export const Timeline = styled.div`
  margin-top: 20px;
  .history-tl-container {
    font-family: 'Roboto', sans-serif;
    width: 50%;
    margin: auto;
    display: block;
    position: relative;
  }
  .history-tl-container ul.tl {
    margin: 20px 0;
    padding: 0;
    display: inline-block;
  }
  .history-tl-container ul.tl li {
    list-style: none;
    margin: auto;
    margin-left: 200px;
    min-height: 50px;

    border-left: 2px solid ${darkSlateBlue};
    padding: 0 0 50px 30px;
    position: relative;
  }
  .history-tl-container ul.tl li:last-child {
    border-left: 0;
  }
  .history-tl-container ul.tl li::before {
    position: absolute;
    left: -10px;
    top: -5px;
    content: ' ';

    border-radius: 500%;
    background: ${darkSlateBlue};
    height: 20px;
    width: 20px;
    transition: all 500ms ease-in-out;
  }
  .history-tl-container ul.tl li:hover::before {
    border-color: ${darkSlateBlue};
    transition: all 1000ms ease-in-out;
  }
  ul.tl li .item-title {
  }
  ul.tl li .item-detail {
    color: rgba(0, 0, 0, 0.5);
    font-size: 12px;
  }
  ul.tl li .timestamp {
    color: #8d8d8d;
    position: absolute;
    width: 100px;
    left: -50%;
    text-align: right;
    font-size: 12px;
  }
  ul.tl li span {
    position: absolute;
    top: -1px;
    left: -3px;
    color: #fff;
    font-size: 11px;
  }
`



// WEBPACK FOOTER //
// ./src/app/pages/DashboardIdentifiersHistory/styles.js